// extracted by mini-css-extract-plugin
module.exports = {"DomainCheck":"DomainCheck_DomainCheck__3JjB6"};